
import { Component, Prop, Vue } from 'vue-property-decorator'
import { useUserStore } from '@/stores/user'

import { User } from '@/models/index'

@Component({
  name: 'Account'
})
export default class extends Vue {
  @Prop({ required: false }) private user!: User

  userStore: any = useUserStore()

  get user_() {
    return this.user || this.userStore.model
  }

  redirectToOauth(): void {
    window.open(`${process.env.VUE_APP_OPENID_SERVER_URL}/users/edit`, '_blank')
  }
}
